import $ from 'jquery'
import Backbone from 'backbone'
import _ from 'lodash'
import mobile from 'scoreboard/components/mobile'

var InfiniteScroller = Backbone.View.extend({

	_loading: false,

	triggerPoint: 750, // 750px from the bottom (needs to be big for #7008)

	events: {
		'scroll': 'checkScroll'
	},

	initialize: function(options) {
		this.options = options
		if (_.size(this.options.el) !== 1) throw new Error('a single el must be specified')
		this.scrollElement = this.el
		this._resetScrollElement()

		// Listen for window resize events so that we can change the scroll element
		// once we switch from/to mobile layout. Doing this here rather than where
		// infinite-scroller is used to make things more DRY
		$(window).on('resize', function() {
			this._resetScrollElement()
		}.bind(this))
	},

	checkScroll: function(e) {
		if (!this._loading && this.el) {
			// scrollTop:    the number of pixels that an element's content is scrolled vertically.
			// scrollHeight: height of an element's content, including content not visible on the screen due to overflow.
			var scrollPosition = this.scrollElement.scrollTop
								 + this._visibleScrollSpace()
								 + this.triggerPoint
			var needDataToFillScrollSpace = scrollPosition > this.scrollElement.scrollHeight
			if (needDataToFillScrollSpace) {
				this._loading = true
				this.trigger('scroll')
				// once scrolling is done, allow more scrolling to happen
				this._loading = false
			}
		} else {
			_.debounce(() => this.trigger('scroll:end'), 600)()
		}
	},

	/*
	 There are two times when we need to evaluate whether we should draw more data
	 on the screen. The first obvious one is when the div scrolls and we have
	 to figure out if the last bit of data will soon be displayed in the viewport.

	 The second event (handled by this method) is when data is ready for display. In
	 the case data is ready for display we evaluate whether the current viewport
	 is filled from top to bottom with data. If it's not, we should continue to
	 fill it with data (by triggering 'scroll') until it is filled.

	 There are two reasons we want the screen filled with data. First, the user
	 probably wants to see as much information at a glance as is available. Showing
	 less than a full viewport would deprive them of data without a performance
	 advantage. Second, unless the viewport is filled, the browser will never
	 be able to send a scroll event since the amount of data displayed will be
	 too small to cause the containing viewport to scroll. This will cause only
	 the first 25 or so rows to ever be shown (whatever the chunker default is).
	*/
	dataReady: function(e) {
		process.nextTick(function() {
			// This needs to take place on the next tick so that we can measure
			// the height of the wrapper element once it's drawn
			if (this.el && this._visibleScrollSpace() >= this.scrollElement.scrollHeight) {
				this.trigger('scroll')
			}
		}.bind(this))
	},

	/*
		Here's where we switch the view element so that the scroll event is always
		fired since it will be watching the correct element whether we're in the
		mobile orientation or not. We're also setting this.scrollElement here so that
		we can get correct calculations for checkScroll() when the way things scroll
		on screen changes.
	 */
	_resetScrollElement: function() {
		// Don't reset the element unless its necessary
		let isMobile = mobile.isMobileWidth()
		let isScrollable = this.$el.hasClass('scroll-container')

		if (isMobile && !this.$el.hasClass('display-layout') && !isScrollable) {
			this.setElement($('.display-layout'))
			this.scrollElement = $('.display-layout')[0]
		// If we're not in the mobile layout or the mobile layout has a scrollable
		// el and the current view element isn't what it was originally set to,
		// reset it to that original el
		} else if (this.el !== this.options.el && (!isMobile || isScrollable)) {
			this.setElement(this.options.el)
			this.scrollElement = this.el
		}
	},

	_visibleScrollSpace: function() {
		// clientHeight: inner height of an element in pixels, including padding but not the horizontal scrollbar height, border, or margin.
		return _.min([this.scrollElement.clientHeight, window.innerHeight])
	}
})

export default InfiniteScroller

InfiniteScroller.__filename__ = 'components/infinite-scroller.js'
